import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { IModalCallbacks } from 'reactApp/components/UploadBigFileDialog/UploadBigFileDialog.types';
import { useGoToSubscriptions } from 'reactApp/hooks/useGoToSubscriptions';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { TariffCard } from 'reactApp/ui/TariffCard/TariffCard';
import { getTariffProductsByPeriods } from 'reactApp/utils/Period';

import styles from '../UploadBigFileDialog.css';

export const useTariff = (callbacks: IModalCallbacks): JSX.Element => {
    const proTariff = useSelector(ProductsSelectors.getProTariffForUser);
    const { yearProduct } = proTariff?.products ? getTariffProductsByPeriods(proTariff.products) : { yearProduct: null };

    const { goToSubscriptions } = useGoToSubscriptions();

    const handleOnTariffsClick = useCallback(() => {
        callbacks.onClose();
        goToSubscriptions();
    }, [callbacks, goToSubscriptions]);

    return (
        <div className={styles.tariffWrapper}>
            <TariffCard
                id={yearProduct?.id}
                tariffId={proTariff?.id}
                flags={proTariff?.flags}
                space={yearProduct?.space}
                price={yearProduct?.price}
                discountPrice={yearProduct?.discountPrice}
                onBuyClick={callbacks.onRequestPayment}
                showOldPrice={false}
                period={yearProduct?.period}
                isPrimary
                isVisible
                withoutTariffIcon
                withoutTariffFeatures
                isProfessional={yearProduct?.isProfessional}
                modificator="quota"
                topLabel
            />
            <div className={styles.showMore} onClick={handleOnTariffsClick}>
                Посмотреть все тарифы
            </div>
        </div>
    );
};
